import VacancyCreate from './VacancyCreate';
export default VacancyCreate
;